import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import PasswordInput from '../components/PasswordInput.jsx';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await login(email, password);
      nav(loc.state?.from?.pathname || '/', { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.error || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="bg-navy h-2" />
      <div className="bg-crimson h-1" />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold mt-2">ASE CRM</h1>
            <div className="rule-crimson mx-auto" />
            <p className="text-muted text-sm">ASE</p>
          </div>

          <form onSubmit={onSubmit} className="card p-6 space-y-4">
            <div>
              <label htmlFor="login-email" className="label">Email</label>
              <input id="login-email" type="email" className="input" value={email} onChange={e => setEmail(e.target.value)}
                     autoComplete="username" required autoFocus />
            </div>
            <div>
              <label htmlFor="login-password" className="label">Password</label>
              <PasswordInput id="login-password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            {err && <div className="text-crimson text-sm">{err}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
            <div className="text-center pt-2">
              <Link to="/forgot-password" className="text-sm text-muted hover:text-crimson">
                Forgot password?
              </Link>
            </div>
          </form>

          <div className="text-center mt-6 text-xs text-muted">
            <Link to="/privacy" className="hover:text-crimson">Privacy Policy</Link>
            <span className="mx-2">·</span>
            <Link to="/sms-terms" className="hover:text-crimson">SMS Terms</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
